module.exports = {
  __init__: [ 'defaultRenderer' ],
  defaultRenderer: [ 'type', require(129) ],
  styles: [ 'type', require(130) ]
};
